// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__9SpX+","other":"Badge_other__sk-kt","coworker":"Badge_coworker__-uDRV","family":"Badge_family__GjGFo","friend":"Badge_friend__7ebik"};